import React, { useContext, useEffect } from "react";
import { apiPut, apiDelete } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { subAdminSorting } from "utils/constants";

const SubTable = ({
  subAdmin,
  handelEdit,
  // handleUserView,
  allSubAdmin,
  page,
  sort,
  setSort,
  manager,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, updatePageName } = useContext(AuthContext);
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.statusSub}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSubAdmin();
      }
    } catch (error) {
      console.log("error in get all sub admin list==>>>>", error.message);
    }
  };
  useEffect(() => {
    updatePageName(t("SUB_ADMIN_MANAGERS"));
  }, []);

  const handleSort = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };

  const handelDelete = async (item) => {
    try {
      const path = apiPath.deleteSubAdmin + "/" + item?._id;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        allSubAdmin();
      }
    } catch (error) {
      console.log("error in get all Sub-Admin list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th scope="col" className="py-3 px-6">
                {t("SUB_ADMIN_ID")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("SUB_ADMIN_NAME")}
              </th>
              {subAdminSorting.map((option) => (
                <th
                  key={option.sortBy}
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => handleSort(option.sortBy, "asc")}
                >
                  <div className="flex justify-start">
                    <span>{option.displayText}</span>
                    <span>
                      {sort.sortBy === option.sortBy &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortBy === option.sortBy &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
              ))}
              {(manager?.add || manager?.edit || user?.role === "admin") && (
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>
              )}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {subAdmin &&
              subAdmin?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">
                    {item?._id}
                  </td>
                  <td className="py-4 px-6 border-r text-gray-900">
                    {item?.name}
                  </td>
                  <td className="py-4 px-6 border-r text-gray-900">
                    {item?.email}
                  </td>
                  <td className="py-4 px-6 border-r text-gray-900">
                    {dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")}
                  </td>
                  {(manager?.add ||
                    manager?.edit ||
                    user?.role === "admin") && (
                    <td className="py-4 px-6 border-r text-center text-gray-900">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure you want to ${
                                e.target.checked ? "active" : "inactive"
                              } '${item.name}'?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className="py-4 px-6 border-l text-gray-900">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.edit || user?.role === "admin") && (
                          <li
                            onClick={() =>
                              navigate("/sub-admin-manager/edit", {
                                state: item,
                              })
                            }
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <a title={t("EDIT_SUB_ADMIN")}>
                              {" "}
                              <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                            </a>
                          </li>
                        )}
                        {user?.role === "admin" && (
                          <li
                            onClick={(e) =>
                              helper.alertFunction(
                                `Are you sure want to delete '${item.name}'?`,
                                item,
                                handelDelete,
                                true
                              )
                            }
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("DELETE_SUBADMIN")}>
                              {" "}
                              <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                            </button>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(subAdmin) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubTable;
